<template>
  <div class="content-wrapper">
    <div class="col-12 mb-primary">
      <div class="card card-with-shadow border-0 h-100">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body">
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            data-url="/admin/comapny/job/store"
          >
            <div class="form-group row align-items-center">
              <label for="inputs_name" class="col-sm-3 mb-0">
                {{ $t("title") }}
              </label>
              <app-input
                id="inputs_name"
                class="col-sm-9"
                type="text"
                v-model="certificate.title"
                :read-only="true"
              />
            </div>
            <div class="form-group row align-items-center">
              <label for="inputs_email" class="col-sm-3 mb-0">
                {{ $t("description") }}
              </label>
              <app-input
                id="inputs_email"
                class="col-sm-9"
                type="textarea"
                v-model="certificate.description"
                :read-only="true"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import {
  COMPANY_JOB_SITE_STORE,
  COMPANY_JOB_STORE,
  CATEGORIES,
  DROPDOWN,
  BUYER_CERTIFICATE_APPLIED_GET,
} from "../../../../../Config/ApiUrl.js";
import { axiosPost, axiosGet } from "../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      preloader: false,
      certificate: {},
    };
  },
  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.save(this.inputs);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {
        gender: "male",
      };
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    beforeSubmit() {
      this.preloader = true;
    },
    storeJob() {
      // this.seen = true;
      let formData = new FormData();
      if (this.dropzone_files.length) {
        this.dropzone_files.forEach((dropzone_file) => {
          formData.append(`dropzone_file[]`, dropzone_file);
        });
      }
      Object.keys(this.job).forEach((key) => {
        formData.append(key, this.job[key]);
      });
      this.save(formData);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      this.job.id = res.data.job_id;
      this.$toastr.s(res.data.message);
      this.job = {};
      window.location = "/buyer/job";
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    getDropdown() {
      axiosGet(DROPDOWN)
        .then((res) => {
          this.regionlist = res.data.region;
          this.threshold = res.data.threshold;
          this.framework = res.data.framework;
          this.noticetypelist = res.data.noticetype;
        })
        .catch((error) => {
          
        });
    },

    getCertificate(id) {
      axiosGet(BUYER_CERTIFICATE_APPLIED_GET + "/" + id)
        .then((res) => {
          this.certificate = res.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    
    // let id = split[7].split("?")[0];
    let id = this.$attrs['props'].certificate_id;
    
    this.getCertificate(id);
  },
};
</script>
